import {
	ApolloClient,
	HttpLink,
	InMemoryCache,
	ApolloLink,
	concat
} from 'apollo-boost'

const httpLink = new HttpLink({
	uri: process.env.VUE_APP_GQL_URL
})

const typenameMiddleware = new ApolloLink((operation, forward) => {
	if (operation.variables) {
		operation.variables = { ...operation.variables, __typename: undefined }
	}
	return forward(operation)
})

const authMiddleware = new ApolloLink((operation, forward) => {
	const vuex = JSON.parse(localStorage.getItem('vuex'))
	const token = vuex.login.token
	operation.setContext({
		headers: { Authorization: `Bearer ${token}` }
	})
	return forward(operation)
})

const client = new ApolloClient({
	link: concat(typenameMiddleware, concat(authMiddleware, httpLink)),
	cache: new InMemoryCache({
		addTypename: false,
		resultCaching: false
	}),
	defaultOptions: {
        watchQuery: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'ignore',
        },
        query: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        },
    }
})

export default client
